import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import page from "../../../../shared/page";
import { getModalAddOrderNumberTemplate } from "./modals/modal-add-order-number";
import { getModalEditTemplate } from "./modals/modal-edit";
import { getModalCallbackTemplate } from "./modals/modal-callback";
import { getModalCloseTemplate } from "./modals/modal-close";
import { getModalEditSuccessTemplate } from "./modals/modal-edit-success";
import { getModalCallbackSuccessTemplate } from "./modals/modal-callback-success";
import { getModalCloseSuccessTemplate } from "./modals/modal-close-success";
import { getModalMissionDetailsTemplate } from "./modals/modal-mission-details";
import { getCreateNewServiceCallModal } from "./modals/modal-create-new-service-call";
import { getServiceTimesModal } from "./modals/modal-service-times";

export default {
    title: "MyTrumpf/Page Templates/My Service Calls/Modals",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        withStoryWrapper: false,
        withNotification: false,
        withServiceTimes: false,
        withEditSuccess: false,
        withCallbackSuccess: false,
        withCloseSuccess: false,
        addOrderNumber: false,
        missonDetail: false,
        missionDetailExtended: false,
        createNewServiceCall: false,
        serviceTimes: false,
        name: "",
    },
    argTypes: {
        withStoryWrapper: {
            control: {
                type: "boolean",
            },
        },
        withNotification: {
            control: {
                type: "boolean",
            },
        },
        withServiceTimes: {
            control: {
                type: "boolean",
            },
        },
        withEditSuccess: {
            control: {
                type: "boolean",
            },
        },
        withCallbackSuccess: {
            control: {
                type: "boolean",
            },
        },
        withCloseSuccess: {
            control: {
                type: "boolean",
            },
        },
        addOrderNumber: {
            control: {
                type: "boolean",
            },
        },
        name: {
            control: {
                type: "text",
            },
        },
        url: {
            control: {
                type: "text",
            },
        },
    },
};

const Template = (args) => {
    const templateArgs = {
        ...args,
    };
    const {
        withStoryWrapper,
        withNotification,
        withServiceTimes,
        withEditSuccess,
        withCallbackSuccess,
        withCloseSuccess,
        addOrderNumber,
        editOrderNumber,
        missionDetail,
        missionDetailExtended,
        createNewServiceCall,
        serviceTimes,
        name,
    } = templateArgs;
    const tpl = html`${missionDetail ||
    missionDetailExtended ||
    createNewServiceCall
        ? html`<ux-button data-trigger-async-modal="open,${name}"
              >${name}</ux-button
          >`
        : html`<ux-button data-trigger-modal="open,${name}"
              >${name}</ux-button
          >`}
    ${withNotification
        ? getNotificationModalTemplate(withServiceTimes, name)
        : ""}
    ${getModalEditTemplate()} ${getModalCallbackTemplate()}
    ${getModalCloseTemplate()}
    ${withEditSuccess ? getModalEditSuccessTemplate(name) : ""}
    ${withCallbackSuccess ? getModalCallbackSuccessTemplate(name) : ""}
    ${withCloseSuccess ? getModalCloseSuccessTemplate(name) : ""}
    ${addOrderNumber ? getModalAddOrderNumberTemplate(false, name) : ""}
    ${editOrderNumber ? getModalAddOrderNumberTemplate(true, name) : ""}
    ${missionDetail
        ? getModalMissionDetailsTemplate(
              "mock-data/service-calls/mission-details-modal.html",
              name
          )
        : ""}
    ${missionDetailExtended
        ? getModalMissionDetailsTemplate(
              "mock-data/service-calls/mission-details-modal-extended.html",
              name
          )
        : ""}
    ${createNewServiceCall ? getCreateNewServiceCallModal(name) : ""}
    ${serviceTimes ? getServiceTimesModal(name) : ""} `;

    return withStoryWrapper ? page(tpl) : tpl;
};

const getNotificationModalTemplate = (withServiceTimes, name) => html`
    <ux-modal name="${name}" close-on-backdrop-click close-on-esc-key>
        <ux-modal-content>
            <div class="ux-u-text-align--center ux-u-mb-xxs">
                <ux-icon
                    style="font-size: 100px"
                    class="ux-color-success"
                    name="checkmark-rounded-thin"
                ></ux-icon>
                <h2 class="ux-text-headline ux-text-headline--big ux-u-my-zero">
                    Your Case was created successfully.
                </h2>
                ${withServiceTimes
                    ? html`
                          <p class="ux-text-normal">
                              Please note that cases created outside out service
                              hours will not be processed immediately. <br />
                              <strong
                                  >Our Service Times are: Monday to Friday 05:30
                                  - 19:00</strong
                              >
                          </p>
                          <p class="ux-text-normal">
                              If you need immediate assistance, please call
                              TRUMPF technical service (+49 7156 123456) for
                              support
                          </p>
                      `
                    : ""}
                <h3 class="ux-text-headline ux-text-headline--big ux-u-my-zero">
                    Technical Guide available
                </h3>

                <p class="ux-text-normal">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
            </div>
        </ux-modal-content>
        <ux-modal-footer>
            <button
                href="#"
                data-trigger-modal="close,notification-modal"
                class="ux-button ux-button--green"
            >
                OK
            </button>
            ${withServiceTimes
                ? html`
                      <span class="ux-modal-footer__spacer"></span>
                      <a href="tel:+497156123456" class="ux-button"
                          >Call Technical Service</a
                      >
                  `
                : ""}
        </ux-modal-footer>
    </ux-modal>
`;

export const WithNotification = (args) => Template(args);
WithNotification.args = {
    withNotification: true,
    name: "notification-modal",
};

export const WithNotificationAndServiceTimes = (args) => Template(args);
WithNotificationAndServiceTimes.args = {
    withNotification: true,
    withServiceTimes: true,
    name: "notification-modal",
};

export const EditSuccess = (args) => Template(args);
EditSuccess.args = {
    withEditSuccess: true,
    name: "modal-edit-success",
};

export const CallbackSuccess = (args) => Template(args);
CallbackSuccess.args = {
    withCallbackSuccess: true,
    name: "modal-callback-success",
};

export const CloseSuccess = (args) => Template(args);
CloseSuccess.args = {
    withCloseSuccess: true,
    name: "modal-close-success",
};

export const AddOrderNumber = (args) => Template(args);
AddOrderNumber.args = {
    addOrderNumber: true,
    name: "add-order-number-modal",
};

export const EditOrderNumber = (args) => Template(args);
EditOrderNumber.args = {
    editOrderNumber: true,
    name: "edit-order-number-modal",
};

export const MissionDetail = (args) => Template(args);
MissionDetail.args = {
    missionDetail: true,
    name: "mission-detail-modal",
};

export const MissionDetailExtended = (args) => Template(args);
MissionDetailExtended.args = {
    missionDetailExtended: true,
    name: "mission-detail-modal-extended",
};

export const CreateNewServiceCall = (args) => Template(args);
CreateNewServiceCall.args = {
    createNewServiceCall: true,
    name: "create-service-call",
};

export const ServiceTimes = (args) => Template(args);
ServiceTimes.args = {
    serviceTimes: true,
    name: "service-times-modal",
};
